"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bnscodec_1 = require("./bnscodec");
const bnsconnection_1 = require("./bnsconnection");
/**
 * A helper to connect to a bns-based chain at a given url
 */
function createBnsConnector(url, expectedChainId) {
    return {
        establishConnection: async () => bnsconnection_1.BnsConnection.establish(url),
        codec: bnscodec_1.bnsCodec,
        expectedChainId: expectedChainId,
    };
}
exports.createBnsConnector = createBnsConnector;
//# sourceMappingURL=bnsconnector.js.map